<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <div class="col-md-3 text-center text-md-right order-md-2">
        <div v-if="organisation.logo" class="pt-2">
          <v-lazy-image :src="organisation.logo" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-9">
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
          class="py-5"
        >
          <template v-slot:fields>
            <form-group label="Name" :required="true">
              <input
                type="text"
                @blur="$v.organisation.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.organisation.name.$error }"
                v-model="organisation.name"
              />

              <div class="invalid-feedback" v-if="!$v.organisation.name.required">
                Please enter name
              </div>
            </form-group>

            <form-group label="Company Code">
              <input
                type="text"
                class="form-control"              
                v-model="organisation.code"
              />
            </form-group>

            <form-group label="Registration Number">
              <input
                type="text"
                class="form-control"
                v-model="organisation.registration_number"
              />
            </form-group>

            <form-group label="Contact Number">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_number"
              />
            </form-group>

            <form-group label="Contact Number 2">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_number_2"
              />
            </form-group>

            <form-group label="Contact Fax">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_fax"
              />
            </form-group>

            <form-group label="Email">
              <input
                type="email"
                class="form-control"
                v-model="organisation.email_address"
              />
            </form-group>


            <form-group label="Website">
              <input
                type="text"
                class="form-control"
                v-model="organisation.website"
              />
            </form-group>

            <form-group label="Physical Address" :required="true">
              <textarea-autosize
                @blur="$v.organisation.physical_address.$touch"
                :class="{ 'is-invalid': $v.organisation.physical_address.$error }"
                class="form-control"
                v-model="organisation.physical_address"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.organisation.physical_address.required"
              >
                Please enter address
              </div>
            </form-group>

            <form-group label="Postal Address">
              <textarea-autosize
                class="form-control"
                v-model="organisation.postal_address"
              />
            </form-group>

            <form-group label="Banking Details" >
              <textarea-autosize
                class="form-control"
                v-model="organisation.banking_details"
              />
            </form-group>

        

            <form-group label="Logo">
              <image-upload
                @files-uploaded="
                  organisation.image_id = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="false"
                :imageCrop="false"
                :validationState="imageVstate"
                acceptedTypes="image/*"
              />
            </form-group>
          </template>
        </form-base>
      </div>
    </b-row>
  </div>
</template>

<script>
import organisationRepo from "@/api/repos/organisationRepo";
import { required} from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  validations: {
    organisation: {
      name: {
        required,
      },
     
      physical_address: {
        required,
      },
      
    },
  },

  mounted() {
    this.getOrganisation();
  },

  props: ["id"],

  data() {
    return {
      organisation: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getOrganisation() {
      try {
        this.loading = true;
        let { data } = await organisationRepo.get(this.id);
        this.organisation = data.organisation;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await organisationRepo.update(this.id, this.organisation);
          this.$root.$bvToast.toast("Organisation Updated", {
            title: "Success",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.$router.push({ name: "organisations" });
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },
};
</script>
